// import { useState } from "react";
// import { MdArrowDropDown } from "react-icons/md";
// import { FiExternalLink } from "react-icons/fi";

// const insightsData = [
//   { title: "Sprint Velocity Reports", description: "Check team's historical delivery rates", link: "#", checked: true },
//   { title: "Current Sprint Backlog", description: "Assess workload in Sprint 8", link: "#", checked: true },
//   { title: "Team Availability", description: "Ensure no overlapping vacations or holidays", link: "#", checked: true },
//   { title: "Previous Sprint Retrospectives", description: "Identify past blockers", link: "#", checked: false },
// ];

// export default function InsightsPanel({insightsData = []}) {
//   const [openItems, setOpenItems] = useState({});

//   const toggleItem = (index) => {
//     setOpenItems((prev) => ({ ...prev, [index]: !prev[index] }));
//   };

//   return (
//     <div className="w-full p-4 text-zinc-200 bg-zinc-800 rounded-lg shadow-md ">
//       <h2 className="mb-4 text-lg font-semibold text-zinc-100">Insights</h2>
//       {insightsData.map((item, index) => (
//         <div key={index} className="flex flex-col p-2 mb-2 text-sm text-zinc-300 bg-zinc-700 border rounded-md">
//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-2 just">
//               {/* <input type="checkbox" checked={item.checked} readOnly className="w-4 h-4" /> */}
//               {/* <a href="#" target="_blank" rel="noopener noreferrer"> */}
//                 {item}
//               {/* </a> */}
//               {/* <FiExternalLink size={20} className="text-gray-300" /> */}
//             </div>
//             {/* <MdArrowDropDown className="text-gray-400 cursor-pointer" onClick={() => toggleItem(index)} /> */}
//           </div>
//           {/* {openItems[index] && <p className="mt-2 text-sm text-gray-300">{item.description}</p>} */}
//         </div>
//       ))}
//       {/* <button className="px-2 py-1 mt-4 text-white border rounded-md bg-zinc-600">Add</button> */}
//     </div>
//   );
// }

// import React, { useState, useEffect, useRef, useCallback } from "react";

// // --- HELPER FUNCTIONS ---

// /**

//  * Formats an ISO date string into a more readable format.

//  * Example: "2025-10-25T21:23:57+00:00" -> "25 Oct 2025 | 2:53 AM" (adjusts to local time)

//  */

// function formatInsightTimestamp(dateString) {

//   if (!dateString) return "Just now";

//   const date = new Date(dateString);

//   return date.toLocaleString("en-GB", {

//     day: "numeric",

//     month: "short",

//     year: "numeric",

//     hour: "numeric",

//     minute: "2-digit",

//     hour12: true,

//   });

// }

// /**

//  * Transforms a single `Message Data` object into the format

//  * our InSightsPanel component expects.

//  */

// function transformMessageDataToInsight(message) {

//   // Combine critical points and insights into one list for the UI

//   const keyPoints = [

//     ...(message.criticalPoints || []),

//     ...(message.insights || []),

//     // You could also map over `actionItems` if they have a string property

//   ];

//   return {

//     id: message.id,

//     timestamp: formatInsightTimestamp(message.created_date_time),

//     sender: message.from?.name || message.from?.email || "Unknown Sender",

//     summary: message.summary || "No summary available.",

//     keyPoints: keyPoints,

//     tone: message.sentiment || "Neutral", // Use sentiment for tone

//     tags: message.objectiveClass || [], // Use objectiveClass for tags

//   };

// }

// // --- COMPONENT ---

// /**

//  * Renders a timeline of insights from an array of message data objects.

//  * @param {Object[]} messages - An array of `Message Data` objects.

//  */

// export default function BriefingTimelinePanel({ messages = [] }) {

//   const [isLoaded, setIsLoaded] = useState(false);

//   const scrollRef = useRef(null);

//   const progressRef = useRef(null);

//   const contentRef = useRef(null);

//   // Transform the prop data into the format the component can render

//   const timelineInsights = messages.map(transformMessageDataToInsight);

//   useEffect(() => {

//     const timer = setTimeout(() => setIsLoaded(true), 100);

//     return () => clearTimeout(timer);

//   }, []);

//   const handleScroll = useCallback(() => {

//     const el = scrollRef.current;

//     const progressEl = progressRef.current;

//     if (!el || !progressEl) return;

//     const scrollTop = el.scrollTop;

//     const scrollHeight = el.scrollHeight;

//     const clientHeight = el.clientHeight;

//     const scrollable = scrollHeight - clientHeight;

//     const percent = scrollable > 0 ? (scrollTop / scrollable) * 100 : 100;

//     progressEl.style.height = `${percent}%`;

//   }, []);

//   useEffect(() => {

//     const el = scrollRef.current;

//     if (!el) return;

//     el.addEventListener("scroll", handleScroll, { passive: true });

//     handleScroll(); // Call once on mount to set initial state

//     return () => el.removeEventListener("scroll", handleScroll);

//   }, [handleScroll]);

//   return (

//     <div className="flex items-center justify-center w-full min-h-[400px] p-8 font-sans antialiased bg-zinc-900/50">

//       <div className="w-full max-w-3xl min-h-[300px] p-8 bg-zinc-800 border border-zinc-700 rounded-lg shadow-sm">

//         {/* Header */}

//         <div className="flex items-center mb-6">

//           <div className="flex-shrink-0 p-2 mr-3 bg-blue-900/40 rounded-lg">

//             <svg

//               className="w-5 h-5 text-blue-400"

//               fill="none"

//               stroke="currentColor"

//               viewBox="0 0 24 24"

//             >

//               <path

//                 strokeLinecap="round"

//                 strokeLinejoin="round"

//                 strokeWidth={2}

//                 d="M9 12h6m-6 4h6m2 5H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z"

//               />

//             </svg>

//           </div>

//           <h2 className="text-xl font-semibold text-zinc-200">Timeline</h2>

//         </div>

//         {/* Scrollable Timeline */}

//         <div

//           ref={scrollRef}

//           className="relative max-h-[400px] overflow-y-auto pr-6 custom-scrollbar"

//         >

//           <div ref={contentRef} className="relative">

//             {/* Grey full track */}

//             <div className="absolute left-3 top-0 w-0.5 h-full bg-zinc-700 rounded-full" />

//             {/* Blue scroll progress */}

//             <div

//               ref={progressRef}

//               className="absolute left-3 top-0 w-0.5 bg-blue-600 rounded-full"

//               style={{

//                 height: "0%",

//                 transition: "height 0.1s linear",

//                 transformOrigin: "top",

//               }}

//             />

//             {/* Items */}

//             <ul className="py-2 space-y-4">

//               {timelineInsights.length > 0 ? (

//                 timelineInsights.map((insight, index) => (

//                   <li

//                     key={insight.id}

//                     className={`relative transition-all duration-300 ${

//                       isLoaded

//                         ? "opacity-100 translate-y-0"

//                         : "opacity-0 translate-y-3"

//                     }`}

//                     style={{ transitionDelay: `${index * 40}ms` }}

//                   >

//                     <div className="flex items-start group">

//                       {/* Dot */}

//                       <span className="absolute z-10 w-3 h-3 -translate-x-1/2 bg-zinc-800 border-2 border-blue-600 rounded-full left-3 top-3 group-hover:bg-blue-900/40" />

//                       {/* Card Content */}

//                       <div className="w-full p-4 ml-8 bg-zinc-800 border border-zinc-700 rounded-lg group-hover:bg-zinc-900/50 group-hover:border-zinc-700">

//                         {/* Header: Timestamp and Sender */}

//                         <div className="flex flex-wrap items-center justify-between gap-2 mb-2">

//                           <div className="flex items-center text-xs font-semibold text-blue-400">

//                             <svg

//                               className="w-3.5 h-3.5 mr-1.5"

//                               fill="none"

//                               stroke="currentColor"

//                               viewBox="0 0 24 24"

//                             >

//                               <path

//                                 strokeLinecap="round"

//                                 strokeLinejoin="round"

//                                 strokeWidth={2}

//                                 d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"

//                               />

//                             </svg>

//                             {insight.timestamp}

//                           </div>

//                           <span className="text-xs font-medium text-zinc-400">

//                             {insight.sender}

//                           </span>

//                         </div>

//                         {/* Summary */}

//                         <h3 className="mb-2 font-semibold text-zinc-200">

//                           {insight.summary}

//                         </h3>

//                         {/* Key Points */}

//                         {insight.keyPoints.length > 0 && (

//                           <div className="mb-3">

//                             <p className="mb-1 text-sm font-medium text-zinc-300">

//                               Key Points:

//                             </p>

//                             <ul className="pl-5 text-sm text-zinc-400 list-disc space-y-0.5">

//                               {insight.keyPoints.map((point, i) => (

//                                 <li key={i}>{point}</li>

//                               ))}

//                             </ul>

//                           </div>

//                         )}

//                         {/* Tags & Tone */}

//                         <div className="flex flex-wrap items-center gap-2">

//                           <p className="text-sm font-medium text-zinc-300">

//                             Tone:

//                           </p>

//                           <span className="px-2 py-0.5 text-xs font-medium text-green-400 bg-green-900/40 rounded-full">

//                             {insight.tone}

//                           </span>

//                           {insight.tags.length > 0 && (

//                             <p className="pl-2 text-sm font-medium text-zinc-300">

//                               Tags:

//                             </p>

//                           )}

//                           {insight.tags.map((tag, i) => (

//                             <span

//                               key={i}

//                               className="px-2 py-0.5 text-xs font-medium text-indigo-400 bg-indigo-900/40 rounded-full"

//                             >

//                               {tag}

//                             </span>

//                           ))}

//                         </div>

//                       </div>

//                     </div>

//                   </li>

//                 ))

//               ) : (

//                 <div className="ml-8 text-sm text-zinc-400">

//                   No insights to display for this thread.

//                 </div>

//               )}

//             </ul>

//           </div>

//         </div>

//         {/* Footer */}

//         <div className="flex items-center justify-between pt-4 mt-4 text-sm text-zinc-400 border-t border-gray-100">

//           <div className="flex items-center">

//             <svg

//               className="w-4 h-4 mr-1.5 text-gray-400"

//               fill="none"

//               stroke="currentColor"

//               viewBox="0 0 24 24"

//             >

//               <path

//                 strokeLinecap="round"

//                 strokeLinejoin="round"

//                 strokeWidth={2}

//                 d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"

//               />

//             </svg>

//             {timelineInsights.length} updates

//           </div>

//           <div className="text-xs text-gray-400">Scroll to explore</div>

//         </div>

//         {/* Scrollbar Styling */}

//         <style jsx>{`

//           .custom-scrollbar::-webkit-scrollbar {

//             width: 6px;

//           }

//           .custom-scrollbar::-webkit-scrollbar-track {

//             background: #f3f4f6;

//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb {

//             background: #d1d5db;

//             border-radius: 3px;

//           }

//           .custom-scrollbar::-webkit-scrollbar-thumb:hover {

//             background: #9ca3af;

//           }

//         `}</style>

//       </div>

//     </div>

//   );

// }

import React, { useState, useEffect, useRef, useCallback } from 'react';

// --- HELPER FUNCTIONS ---

/**
 * Formats an ISO date string into a more readable format.
 * Example: "2025-10-25T21:23:57+00:00" -> "25 Oct 2025 | 2:53 AM" (adjusts to local time)
 */
function formatInsightTimestamp(dateString) {
  if (!dateString) return 'Just now';
  const date = new Date(dateString);
  return date.toLocaleString('en-GB', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true,
  });
}

/**
 * Transforms a single `Message Data` object into the format
 * our InSightsPanel component expects.
 */
function transformMessageDataToInsight(message) {
  // Combine critical points and insights into one list for the UI
  // Ensure they are arrays, in case the API returns strings
  const getArray = (val) => (Array.isArray(val) ? val : val ? [val] : []);

  const keyPoints = [
    ...getArray(message?.criticalPoints),
    ...getArray(message?.insights),
    // You could also map over `actionItems` if they have a string property
  ];

  return {
    id: message?.id || Math.random().toString(),
    timestamp: formatInsightTimestamp(
      message?.created_date_time || message?.date,
    ),
    sender:
      message?.from?.name ||
      message?.from?.email ||
      message?.from ||
      'Unknown Sender',
    summary: message?.summary || 'No summary available.',
    keyPoints: keyPoints,
    tone: message?.sentiment || 'Neutral', // Use sentiment for tone
    tags: getArray(message?.objectiveClass || message?.category), // Use objectiveClass for tags
  };
}

// --- SUB-COMPONENT for Insight Item ---
// Extracted for easier state management

const InsightItem = ({ insight, index, isLoaded }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const pointsToShow = isExpanded
    ? insight.keyPoints
    : insight.keyPoints.slice(0, 2);

  const handleToggleExpand = () => {
    setIsExpanded((prev) => !prev);
  };

  return (
    <li
      key={insight.id}
      className={`relative transition-all duration-300 ${
        isLoaded ? 'translate-y-0 opacity-100' : 'translate-y-3 opacity-0'
      }`}
      style={{ transitionDelay: `${index * 40}ms` }}
    >
      <div className="group flex items-start">
        {/* Dot */}
        <span className="absolute left-3 top-3 z-10 h-3 w-3 -translate-x-1/2 rounded-full border-2 border-blue-600 bg-zinc-800 group-hover:bg-blue-900/40" />

        {/* Card Content */}
        <div className="ml-8 w-full rounded-lg border border-zinc-700/50 bg-zinc-800/40 p-3 transition-colors group-hover:bg-zinc-700/30">
          {/* Header: Timestamp and Sender */}
          <div className="mb-2 flex flex-wrap items-center justify-between gap-2">
            <div className="flex items-center text-xs font-semibold text-blue-400">
              <svg
                className="mr-1.5 h-3.5 w-3.5"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                />
              </svg>
              {insight.timestamp}
            </div>
            <span className="text-xs font-medium text-zinc-400">
              {insight.sender}
            </span>
          </div>

          {/* Summary */}
          <h3 className="mb-2 font-semibold text-zinc-200">
            {insight.summary}
          </h3>

          {/* Key Points */}
          {insight.keyPoints.length > 0 && (
            <div className="mb-3">
              <p className="mb-1 text-sm font-medium text-zinc-300">
                Key Points:
              </p>
              <ul className="list-disc space-y-0.5 pl-5 text-xs text-zinc-400">
                {pointsToShow.map((point, i) => (
                  <li key={i}>{point}</li>
                ))}
              </ul>
              {/* Expand/Collapse Button */}
              {insight.keyPoints.length > 2 && (
                <button
                  onClick={handleToggleExpand}
                  className="mt-1 text-xs font-medium text-blue-400 hover:underline focus:outline-none"
                >
                  {isExpanded
                    ? 'Show less'
                    : `Show ${insight.keyPoints.length - 2} more...`}
                </button>
              )}
            </div>
          )}

          {/* Tags & Tone */}
          <div className="flex flex-wrap items-center gap-2">
            <p className="text-sm font-medium text-zinc-300">Tone:</p>
            <span className="rounded-full bg-green-900/40 px-2 py-0.5 text-xs font-medium text-green-400">
              {insight.tone}
            </span>

            {insight.tags.length > 0 && (
              <p className="pl-2 text-sm font-medium text-zinc-300">Tags:</p>
            )}
            {insight.tags.map((tag, i) => (
              <span
                key={i}
                className="rounded-full bg-indigo-900/40 px-2 py-0.5 text-xs font-medium text-indigo-400"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      </div>
    </li>
  );
};

// --- MAIN COMPONENT ---

/**
 * Renders a timeline of insights from an array of message data objects.
 *
 * Supports two usage modes:
 *  1. Legacy: Pass `messages` array directly (e.g., from communication tab).
 *  2. Self-fetching: Pass `conversationId` + `isOutlook` + optional `fallbackEmail`.
 *     The component will fetch the thread from the API, mirroring how EmailContent does it.
 *
 * @param {Object[]} [messages] - An array of Message Data objects (legacy mode).
 * @param {string}   [conversationId] - The conversation/thread ID to fetch.
 * @param {boolean}  [isOutlook=false] - Whether to use the Outlook thread API.
 * @param {Object}   [fallbackEmail] - A single email to show while loading or if fetch fails.
 */
export default function BriefingTimelinePanel({
  messages,
  conversationId,
  isOutlook = false,
  fallbackEmail,
}) {
  const [isLoaded, setIsLoaded] = useState(false);
  const [fetchedMessages, setFetchedMessages] = useState(null);
  const [isFetching, setIsFetching] = useState(false);
  const scrollRef = useRef(null);
  const progressRef = useRef(null);
  const contentRef = useRef(null);

  // --- Fetch thread by conversationId (mirrors dialog/EmailModal.jsx logic) ---
  useEffect(() => {
    if (!conversationId) return;

    const fetchThread = async () => {
      setIsFetching(true);
      try {
        // Dynamically import to avoid adding more top-level imports
        const { getGmailEmailThread, getOutlookEmailThread } =
          await import('../../services/api');

        const fetchFn = isOutlook ? getOutlookEmailThread : getGmailEmailThread;
        // Read the JWT token the same way the rest of the app does
        const token = localStorage.getItem('projectToken') || '';
        const response = await fetchFn(token, conversationId);

        if (response?.emails?.length > 0) {
          setFetchedMessages(response.emails);
        } else if (fallbackEmail) {
          setFetchedMessages([fallbackEmail]);
        }
      } catch {
        // On error fall back to the single email
        if (fallbackEmail) setFetchedMessages([fallbackEmail]);
      } finally {
        setIsFetching(false);
      }
    };

    fetchThread();
  }, [conversationId, isOutlook, fallbackEmail]);

  // Determine the final list of messages to display:
  //   - If a `messages` prop was passed (legacy mode), use it directly.
  //   - Otherwise use whatever we fetched (or fallback).
  const resolvedMessages = (() => {
    if (Array.isArray(messages) && messages.length > 0) return messages;
    if (Array.isArray(fetchedMessages) && fetchedMessages.length > 0)
      return fetchedMessages;
    // If still loading and we have a fallbackEmail, show it so the panel isn't empty
    if (fallbackEmail) return [fallbackEmail];
    return [];
  })();

  // Transform the resolved messages
  const timelineInsights = resolvedMessages.map(transformMessageDataToInsight);

  useEffect(() => {
    const timer = setTimeout(() => setIsLoaded(true), 100);
    return () => clearTimeout(timer);
  }, []);

  const handleScroll = useCallback(() => {
    const el = scrollRef.current;
    const progressEl = progressRef.current;
    if (!el || !progressEl) return;

    const scrollTop = el.scrollTop;
    const scrollHeight = el.scrollHeight;
    const clientHeight = el.clientHeight;
    const scrollable = scrollHeight - clientHeight;

    const percent = scrollable > 0 ? (scrollTop / scrollable) * 100 : 100;
    progressEl.style.height = `${percent}%`;
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;
    el.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll(); // Call once on mount to set initial state
    return () => el.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  return (
    <div className="w-full p-5">
      <span className="mb-4 block text-[10px] font-semibold uppercase tracking-widest text-zinc-400">
        ⏳ Timeline
      </span>

      {/* Loading skeleton */}
      {isFetching && (
        <div className="mb-3 space-y-2">
          {[1, 2].map((i) => (
            <div
              key={i}
              className="ml-8 h-16 animate-pulse rounded-lg bg-zinc-700/40"
            />
          ))}
        </div>
      )}

      {/* Scrollable Timeline */}
      {!isFetching && (
        <div
          ref={scrollRef}
          className="custom-scrollbar relative max-h-[400px] overflow-y-auto pr-6"
        >
          <div ref={contentRef} className="relative">
            {/* Grey full track */}
            <div className="absolute left-3 top-0 h-full w-0.5 rounded-full bg-zinc-700" />

            {/* Blue scroll progress */}
            <div
              ref={progressRef}
              className="absolute left-3 top-0 w-0.5 rounded-full bg-blue-600"
              style={{
                height: '0%',
                transition: 'height 0.1s linear',
                transformOrigin: 'top',
              }}
            />

            {/* Items */}
            <ul className="space-y-4 py-2">
              {timelineInsights.length > 0 ? (
                timelineInsights.map((insight, index) => (
                  <InsightItem
                    key={insight.id}
                    insight={insight}
                    index={index}
                    isLoaded={isLoaded}
                  />
                ))
              ) : (
                <div className="ml-8 text-sm text-zinc-400">
                  No insights to display for this thread.
                </div>
              )}
            </ul>
          </div>
        </div>
      )}

      {/* Footer */}
      <div className="mt-4 flex items-center justify-between border-t border-zinc-700/50 pt-4 text-xs text-zinc-400">
        <div className="flex items-center">
          <svg
            className="mr-1.5 h-4 w-4 text-gray-400"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          {timelineInsights.length} updates
        </div>
        {!isFetching && (
          <div className="text-xs text-gray-400">Scroll to explore</div>
        )}
      </div>

      {/* Scrollbar Styling */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: transparent;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #52525b;
          border-radius: 3px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #71717a;
        }
      `}</style>
    </div>
  );
}
